import React, { ComponentProps } from 'react';
import { clsx } from 'clsx';

import styles from './Label.module.scss';

export interface LabelProps extends ComponentProps<'label'> {
  children: React.ReactNode;
}

export const Label = ({ children, className, ...rest }: LabelProps) => (
  <label {...rest} className={clsx(styles.label, className)}>
    {children}
  </label>
);
